import { prop } from '../../../common/utils/immutableHelper';

export const getReactionUserId = prop('userId');
export const getReactionEmojiCode = prop('emojiCode');
